/**
 * Internal dependencies
 */
import {
	CRDT_DOC_META_PERSISTENCE_KEY,
	CRDT_RECORD_MAP_KEY,
	CRDT_RECORD_METADATA_MAP_KEY,
	CRDT_RECORD_METADATA_SAVED_AT_KEY,
	CRDT_RECORD_METADATA_SAVED_BY_KEY,
	LOCAL_EDITOR_ORIGIN,
	LOCAL_SYNC_MANAGER_ORIGIN,
	WORDPRESS_META_KEY_FOR_CRDT_DOC_PERSISTENCE,
} from './config';
import { lock } from './lock-unlock';
import { createSyncManager } from './manager';
import { default as Delta } from './quill-delta/Delta';

export const privateApis = {};

lock( privateApis, {
	createSyncManager,
	Delta,
	CRDT_DOC_META_PERSISTENCE_KEY,
	CRDT_RECORD_MAP_KEY,
	CRDT_RECORD_METADATA_MAP_KEY,
	CRDT_RECORD_METADATA_SAVED_AT_KEY,
	CRDT_RECORD_METADATA_SAVED_BY_KEY,
	LOCAL_EDITOR_ORIGIN,
	LOCAL_SYNC_MANAGER_ORIGIN,
	WORDPRESS_META_KEY_FOR_CRDT_DOC_PERSISTENCE,
} );
